// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { copyGrid as copyGridAction } from '../actions/basket';
import GridsCopyGridButton from '../components/buttons/GridsCopyGridButton';
import { getGrid } from '../selectors/grids';
import { getPool } from '../selectors/pool';
import Pool from '../states/pool';

const legacySelector = memoize((state, { gridReference }) => {
  const grid = getGrid(state, gridReference);

  let isVisible = false;
  let selectionsToCopy = null;
  let redirectLink = null;
  if (grid) {
    const { isSystem, strGridSelection, systemStrGridSelections, poolId } = grid;
    const pool = getPool(state, poolId);

    isVisible = Pool.isActive(pool);
    selectionsToCopy = isSystem ? systemStrGridSelections : [strGridSelection];

    redirectLink = Pool.getLinkFromPoolId(poolId);
  }

  return {
    isVisible,
    grid,
    selectionsToCopy,
    redirectLink,
  };
});

type GridsCopyGridButtonContainerProps = {
  className?: string;
  gridReference: string;
};

const GridsCopyGridButtonContainer = ({ gridReference, ...ownProps }: GridsCopyGridButtonContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector((state) => legacySelector(state, { gridReference }));

  const copyGrid = useCallback(
    (grid) => {
      dispatch(copyGridAction(grid));
    },
    [dispatch],
  );

  const otherProps = useMemo(() => ({ copyGrid }), [copyGrid]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsCopyGridButton {...enhancedProps} />;
};

export default GridsCopyGridButtonContainer;
